import React, { useState, useEffect } from "react";
import "./styles/AgentSelector.css"; // Import CSS file

const AgentSelector = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [locations, setLocations] = useState([]);

  const [counties, setCounties] = useState([]);
  const [selectedCounty, setSelectedCounty] = useState("");

  const [towns, setTowns] = useState([]);
  const [selectedTown, setSelectedTown] = useState("");

  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");

  const [specifics, setSpecifics] = useState([]);

  const [price, setPrice] = useState("");
  const [commissionAmount, setCommissionAmount] = useState(0);
  const [commissionPercentage, setCommissionPercentage] = useState(0);

  useEffect(() => {
    fetchAgentLocations();
  }, []);

  const fetchAgentLocations = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await fetch("https://esystem-1zd8.onrender.com/api/locationsroutes");
      const data = await response.json();

      if (data.success) {
        setLocations(data.locations);
        const uniqueCounties = [...new Set(data.locations.map((loc) => loc.locations?.county))];
        setCounties(uniqueCounties.filter(Boolean));
      } else {
        setError("Failed to fetch locations.");
      }
    } catch (err) {
      setError("Error fetching locations.");
    } finally {
      setLoading(false);
    }
  };

  const handleCountyChange = (e) => {
    setSelectedCounty(e.target.value);
    setSelectedTown("");
    setSelectedArea("");
    setSpecifics([]);
    setTowns(locations.filter((loc) => loc.locations?.county === e.target.value).map((loc) => loc.locations?.town));
  };

  const handleTownChange = (e) => {
    setSelectedTown(e.target.value);
    setSelectedArea("");
    setSpecifics([]);
    setAreas(locations.filter((loc) => loc.locations?.town === e.target.value).map((loc) => loc.locations?.area));
  };

  const handleAreaChange = (e) => {
    setSelectedArea(e.target.value);
    setSpecifics(
      locations
        .filter((loc) => loc.locations?.town === selectedTown && loc.locations?.area === e.target.value)
        .map((loc) => loc.locations?.specific)
    );
  };

  const getPercentage = (price) => {
    if (price < 250) return 0.15;
    if (price < 500) return 0.12;
    if (price < 2000) return 0.10;
    if (price < 3000) return 0.09;
    if (price < 5000) return 0.08;
    if (price < 100000) return 0.05;
    return 0.04;
  };

  const handlePriceChange = (e) => {
    const enteredPrice = parseFloat(e.target.value) || 0;
    setPrice(enteredPrice);
    const percentage = getPercentage(enteredPrice);
    setCommissionPercentage(percentage * 100);
    setCommissionAmount(enteredPrice * percentage);
  };

  return (
    <div className="container">
      <h2 className="title">Find an Agent & Calculate Commission</h2>

      <div className="card">
        <div className="form-group">
          <label>County:</label>
          <select value={selectedCounty} onChange={handleCountyChange} disabled={loading || counties.length === 0}>
            <option value="">-- Select County --</option>
            {counties.map((county, index) => (
              <option key={index} value={county}>{county}</option>
            ))}
          </select>
        </div>

        {towns.length > 0 && (
          <div className="form-group">
            <label>Town:</label>
            <select value={selectedTown} onChange={handleTownChange}>
              <option value="">-- Select Town --</option>
              {towns.map((town, index) => (
                <option key={index} value={town}>{town}</option>
              ))}
            </select>
          </div>
        )}

        {areas.length > 0 && (
          <div className="form-group">
            <label>Area:</label>
            <select value={selectedArea} onChange={handleAreaChange}>
              <option value="">-- Select Area --</option>
              {areas.map((area, index) => (
                <option key={index} value={area}>{area}</option>
              ))}
            </select>
          </div>
        )}

        {specifics.length > 0 && (
          <div className="specific-list">
            <h3>Specific Locations:</h3>
            <ul>
              {specifics.map((specific, index) => (
                <li key={index}>{specific}</li>
              ))}
            </ul>
          </div>
        )}
      </div>

      <div className="calculator">
        <h3>Commission Calculator</h3>
        <label>Product Price:</label>
        <input type="number" value={price} onChange={handlePriceChange} placeholder="Enter price" />
        {price > 0 && (
          <div className="commission-result">
            <p>💰 Commission Amount: <strong>Ksh {commissionAmount.toFixed(2)}</strong></p>
            <p>📊 Commission Percentage: <strong>{commissionPercentage}%</strong></p>
          </div>
        )}
      </div>

      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default AgentSelector;
